import React from 'react';
import { PlusCircle, Pencil, Trash2 } from 'lucide-react';
import { useProductStore } from '../../store/productStore';
import { ProductModal } from './ProductModal';

export const ProductList = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [editingProduct, setEditingProduct] = React.useState<string | null>(null);
  const { products, deleteProduct } = useProductStore();
  const [showDeleteConfirm, setShowDeleteConfirm] = React.useState<string | null>(null);

  const handleEdit = (id: string) => {
    setEditingProduct(id);
    setIsModalOpen(true);
  };

  const handleDelete = (id: string) => {
    setShowDeleteConfirm(id);
  };

  const confirmDelete = () => {
    if (showDeleteConfirm) {
      deleteProduct(showDeleteConfirm);
      setShowDeleteConfirm(null);
    }
  };

  const mainProducts = products.filter(p => !p.type || p.type === 'main');
  const bumpProducts = products.filter(p => p.type === 'bump');

  return (
    <div className="space-y-8">
      <div className="bg-white rounded-lg shadow-sm p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-900">Main Products</h2>
          <button
            onClick={() => setIsModalOpen(true)}
            className="btn"
          >
            <PlusCircle className="w-4 h-4 mr-2" />
            Add Product
          </button>
        </div>

        <div className="divide-y divide-gray-200">
          {mainProducts.map((product) => (
            <div key={product.id} className="py-4 flex items-center justify-between">
              <div className="flex-1">
                <h3 className="text-sm font-medium text-gray-900">{product.name}</h3>
                <p className="text-sm text-gray-500">₹{Number(product.price).toFixed(2)}</p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => handleEdit(product.id)}
                  className="p-1 text-gray-400 hover:text-gray-600"
                >
                  <Pencil className="w-4 h-4" />
                </button>
                <button
                  onClick={() => handleDelete(product.id)}
                  className="p-1 text-gray-400 hover:text-red-500"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-900">Bump Offers</h2>
        </div>

        <div className="divide-y divide-gray-200">
          {bumpProducts.map((product) => (
            <div key={product.id} className="py-4 flex items-center justify-between">
              <div className="flex-1">
                <h3 className="text-sm font-medium text-gray-900">{product.name}</h3>
                <p className="text-sm text-gray-500">₹{Number(product.price).toFixed(2)}</p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => handleEdit(product.id)}
                  className="p-1 text-gray-400 hover:text-gray-600"
                >
                  <Pencil className="w-4 h-4" />
                </button>
                <button
                  onClick={() => handleDelete(product.id)}
                  className="p-1 text-gray-400 hover:text-red-500"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Delete Product</h3>
            <p className="text-gray-600 mb-6">Are you sure you want to delete this product? This action cannot be undone.</p>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowDeleteConfirm(null)}
                className="btn btn-secondary"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="btn bg-red-600 hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <ProductModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditingProduct(null);
        }}
        productId={editingProduct}
      />
    </div>
  );
};